import React from "react";
import classNames from "classnames";
import GrComponentFactory from "../gr_component_factory";
import UserIcon from "../user/user_icon";
import { ICON_SIZES } from "../../modules/shape_icon_values";
import NewsfeedItemHeaderTimestamp from "./newsfeed_item_header_timestamp";
import NewsfeedItemFooter from "./footer/newsfeed_item_footer";
import UserProfileLink from "../user/user_profile_link";

export default GrComponentFactory.createClass({
  displayName: "SocialUpdate",

  propTypes: {
    header: React.PropTypes.element,
    body: React.PropTypes.element.isRequired,
    resource: React.PropTypes.object.isRequired,
    additionalFooterLinks: React.PropTypes.arrayOf(React.PropTypes.element),
  },

  getDefaultProps(){
    return {
      header: null,
      isChildNewsfeedItem: false,
    };
  },

  renderHeader() {
    const resourceUser = this.props.resource.user;
    if (resourceUser) {
      return (
        <div className="gr-newsfeedItem__header gr-newsfeedItem__header--timestamp">
          <UserProfileLink user={resourceUser} className="u-marginRightTiny"/>
          {this.props.header}
        </div>
      );
    }
  },

  renderHeaderIcon() {
    const resourceUser = this.props.resource.user;
    if (resourceUser) {
      return (
        <div className="gr-newsfeedItem__headerIcon gr-mediaBox__media gr-mediaBox__media--marginSmall">
          <UserIcon user={resourceUser} size={ICON_SIZES.MEDIUM}/>
        </div>
      );
    }
  },

  render() {
    const newsfeedItemClasses =
      classNames("gr-newsfeedItem", "gr-mediaBox",
        { "gr-childNewsfeedItemContainer": this.props.isChildNewsfeedItem });

    return (
      <div className={newsfeedItemClasses}>
        {this.renderHeaderIcon()}
        <div className="gr-mediaBox__desc gr-newsfeedItem__body">
          {this.renderHeader()}
          <NewsfeedItemHeaderTimestamp time={this.props.updatedAt}
                                       resourceDisplayName={this.props.resourceDisplayName}
                                       resourceUrl={this.props.resourceUrl}/>

          {this.props.body}
        </div>

        <NewsfeedItemFooter
          user={this.props.user}
          like={this.props.social.liking}
          comment={this.props.social.commenting}
          book={this.props.book}
          additionalFooterLinks={this.props.additionalFooterLinks}
          />
      </div>
    );
  },


});
